import cx from "classnames";
import { Maybe } from "graphql/jsutils/Maybe";
import { Hr_Runner } from "@/graphql/gql/graphql";
import { hasRaceStarted } from "@/utils/horseRacing";
import { filterEmpty } from "@/utils/index";
import { HorseInfo, OddsBtn, SilkNum } from "../tableCells";
import PickCell from "../tableCells/PickCell";
import styles from "./raceInfo.module.scss";

interface ConsensusInfoTableRowProps {
  runners: Maybe<Maybe<Hr_Runner>[]> | undefined;
  numerator: Maybe<number>;
  denominator: Maybe<number>;
  fdrLink: string;
  saddleColor: string | undefined;
  numberColor: string | undefined;
  pickSources?: ("timeform" | "handicapping")[];
  raceNumber: Maybe<string> | number | undefined;
  trackName: Maybe<string> | undefined;
  postTime: Maybe<string> | undefined;
}

const ConsensusInfoTableRow = ({
  runners,
  numerator,
  denominator,
  fdrLink,
  saddleColor,
  numberColor,
  pickSources,
  raceNumber,
  trackName,
  postTime,
}: ConsensusInfoTableRowProps) => {
  const runner = filterEmpty(runners ?? [])[0];

  if (!runner || !pickSources) return <></>;
  return (
    <tr className={cx(styles.tableRow, runner.scratched && styles.scratched)}>
      <td className={styles.tableCol}>
        <SilkNum
          saddleColor={saddleColor}
          runner={runner}
          numberColor={numberColor}
        />
      </td>
      <td colSpan={5} className={cx(styles.tableCol, styles.middle)}>
        <HorseInfo
          saddleColor={saddleColor}
          runner={runner}
          numberColor={numberColor}
        />
      </td>
      <td>
        <PickCell pick={runner[pickSources[0]]?.freePick?.number} />
      </td>
      <td>
        <PickCell pick={runner[pickSources[1]]?.freePick?.number} />
      </td>
      <td className={styles.tableCol}>
        <OddsBtn
          numerator={numerator ?? undefined}
          denominator={denominator ?? undefined}
          runner={runner}
          fdrLink={fdrLink}
          raceNumber={raceNumber}
          trackName={trackName}
          disabled={hasRaceStarted(postTime)}
        />
      </td>
    </tr>
  );
};

export default ConsensusInfoTableRow;
